import { DefaultButton, IconButton, Modal, PrimaryButton } from '@fluentui/react'
import React, { useContext } from 'react';
import "./styles/ConfirmModalCss.css";
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import ModalMain from './ModalMain';
import { t } from "i18next";
import themeContext from '../../context/theme/ThemeContext';

const DialogBox = (props) => {
      const showOnlyOkButton = props.showOnlyOkButton != null && props.showOnlyOkButton != undefined ? props.showOnlyOkButton : false;
      const {getThemeColor} = useContext(themeContext);
      let DefaultButtonList = [
        {
          title: t("button.no"),
          onclick: () => props.setShowDialogBox(false),
        },
      ];

    let PrimaryButtonList = [
        {
            title: props.confirmButtonText,
            onclick: () => {
                props.setShowDialogBox(false);
                if(props.onConfirmButtonClick != undefined){
                    props.onConfirmButtonClick()
                }
               }
        }
    ]

    const modalDetails = {
        header: (
          <ModalHeader
            updatedModal={true}
            heading={props.title}
            handleCancel={() => props.setShowDialogBox(false)}
          />
        ),
        body: <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>{props.message}</div>,
        footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={!showOnlyOkButton ? DefaultButtonList : []} />,
        width: "500px",
      };

  return (
    <>
   {props.showDialogBox && <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />}
   </>
  )
}

export default DialogBox